import { Calendar, Clock, MapPin, Trophy } from "lucide-react";
import { cn } from "@/lib/utils";
import { LiveBadge } from "@/components/common/LiveBadge";

// status: "upcoming" | "live" | "completed"
export const MatchCard = ({ match, className }) => {
  const { homeTeam, awayTeam, date, kickOff, competition, venue, status, platform, result } = match;

  return (
    <div
      data-testid="match-card"
      className={cn("border border-border-dark bg-surface-dark p-6 transition-colors hover:border-brand-purple/60", className)}
    >
      <div className="flex items-center justify-between gap-3">
        <span className="inline-flex items-center gap-1.5 font-subheading text-xs font-semibold uppercase tracking-widest text-white/40">
          <Trophy className="h-3.5 w-3.5" /> {competition}
        </span>
        {status === "live" ? <LiveBadge isLive /> : (
          <span className="font-subheading text-xs font-semibold uppercase tracking-widest text-white/40">
            {status === "completed" ? "Full Time" : "Upcoming"}
          </span>
        )}
      </div>

      <div className="mt-6 grid grid-cols-3 items-center gap-2 text-center">
        <p className="font-heading text-xl uppercase text-white sm:text-2xl">{homeTeam}</p>
        <p className="font-heading text-lg text-white/30">{result || "VS"}</p>
        <p className="font-heading text-xl uppercase text-white sm:text-2xl">{awayTeam}</p>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 border-t border-border-dark pt-5 text-xs text-white/50 sm:grid-cols-4">
        <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" /> {date}</span>
        <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {kickOff}</span>
        <span className="flex items-center gap-1.5 sm:col-span-2"><MapPin className="h-3.5 w-3.5" /> {venue}</span>
      </div>

      {platform && (
        <p className="mt-4 font-subheading text-xs font-semibold uppercase tracking-widest text-brand-purple">Coverage: {platform}</p>
      )}
    </div>
  );
};
